module.exports = __webpack_public_path__ + "img/scratchy-small.c3080e29.svg";